"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Environment = void 0;
var Environment;
(function (Environment) {
    Environment["LOCAL"] = "local";
    Environment["DEV"] = "dev";
    Environment["STG"] = "stg";
    Environment["QAT"] = "qat";
    Environment["PROD"] = "prd";
    Environment["UNKNOWN"] = "unknown";
})(Environment = exports.Environment || (exports.Environment = {}));
//# sourceMappingURL=env.util.js.map